// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    AddWishList,
    ExecuteOnErrorCallback,
    ExecuteOnSuccessCallback,
    ResetWishListData,
    SendAddToWishListEvent,
} from "@insite/client-framework/Store/Data/WishLists/Handlers/AddToWishList";
import { WishListModel } from "@insite/client-framework/Types/ApiModels";
import { addWishListLinesWithProperties, PostWishListKitLineModel } from "@store/Framework/Services/WishListKitService";
import { KitProductInfo } from "@store/Framework/Types/KitProductInfo";
import { hasKitConfiguration } from "@store/Framework/Utilities/KitProductInfoUtilities";

export interface AddToWishListWithKitParameter {
    productInfos: KitProductInfo[];
    selectedWishList?: WishListModel;
    newListName?: string;
    onSuccess?: (wishList: WishListModel) => void;
    onError?: (errorMessage: string) => void;
}

interface Props {
    result: {
        wishList?: WishListModel;
        errorMessage?: string;
    };
}

type HandlerType = Handler<AddToWishListWithKitParameter, Props>;

export const AddLineToWishListWithKit: HandlerType = async props => {
    if (!props.result.wishList) {
        return;
    }

    try {
        const lines = props.parameter.productInfos.map<PostWishListKitLineModel>((productInfo: KitProductInfo) => {
            const line: PostWishListKitLineModel = {
                productId: productInfo.productId,
                qtyOrdered: productInfo.qtyOrdered,
                unitOfMeasure: productInfo.unitOfMeasure,
            };

            // Only sent for a configured kit, so a plain product posts exactly the same body as before.
            if (hasKitConfiguration(productInfo)) {
                line.properties = { kitConfiguration: JSON.stringify(productInfo.kitConfiguration) };
            }

            return line;
        });

        await addWishListLinesWithProperties({ wishList: props.result.wishList, lines });
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        if (error?.status === 404) {
            props.result.errorMessage = error.errorMessage;
            return;
        }
        throw error;
    }
};

export const chain = [
    AddWishList,
    AddLineToWishListWithKit,
    ResetWishListData,
    SendAddToWishListEvent,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
] as HandlerType[];

const addToWishListWithKit = createHandlerChainRunner(chain, "AddToWishListWithKit");
export default addToWishListWithKit;
